import {
  Box, Button, Flex, Icon, Stack,
} from '@chakra-ui/react';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import Logo from '../Logo/Logo';
import createLinks from './Links';
import SidebarBox from './SidebarBox';
import PlanDetails from '../PlanDetails';

const Sidebar = ({ routes = [] }) => {
  const links = <>{createLinks(routes)}</>;

  return (
    <SidebarBox>
      <Flex justify="space-between" direction="column" h="100%">
        <Box>
          <Box><Logo /></Box>
          <Stack direction="column" mb="40px">
            <Box>{links}</Box>
          </Stack>
        </Box>
        <Box>
          <PlanDetails />
          <Button
            leftIcon={<Icon as={BsFillQuestionCircleFill} />}
            variant="ghost"
            size="sm"
            color="gray.400"
            as={Link}
            to="/help"
            w="100%"
            justifyContent="flex-start"
          >
            Help
          </Button>
        </Box>
      </Flex>
    </SidebarBox>
  );
};

export default Sidebar;
